import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider, useUser } from './context/UserContext';
import GlobalHeader from './components/GlobalHeader';
import AllGames from './pages/AllGames';
import Leaderboard from './pages/Leaderboard';
import About from './pages/About';
import LoggedOut from './pages/LoggedOut';
import Settings from './pages/Settings';
import './App.css';
import Footer from './components/Footer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import axios from 'axios';

function AppRoutes() {
  const { user, loading } = useUser();
  const [toastShown, setToastShown] = useState(false);

  useEffect(() => {
    if (user && !toastShown) {
      toast.success(
        <div>
          You're in, {user.displayName}!<br />
          Loading the HYPE.
        </div>
      );
      setToastShown(true);
    }
  }, [user, toastShown]);

  if (loading) {
    // Still waiting for Firebase to tell us if user is logged in
    return <div>Loading...</div>; // optional: splash screen
  }

  if (!user) {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="/logged-out" replace />} />
        <Route path="/logged-out" element={<LoggedOut />} />
      </Routes>
    );
  }

  return (
    <>
      <GlobalHeader />
      <Routes>
        <Route path="/" element={<Leaderboard />} />
        <Route path="/games" element={<AllGames />} />
        <Route path="/about" element={<About />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </>
  );
}

export default function App() {
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/ping`)
      .then(() => console.log('🔔 Backend pinged to wake up'))
      .catch(err => console.warn('⚠️ Backend ping failed', err.message));
  }, []);

  return (
    <UserProvider>
      <Router>
        <ToastContainer theme="dark" position="bottom-center" autoClose={2000} closeOnClick />
        <AppRoutes />
      </Router>
    </UserProvider>
  );
}
